import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AuthService } from '../services/auth.service'

export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.isLoggedIn()) {
      const token = localStorage.getItem('auth.token')
      const token_type = localStorage.getItem('auth.token_type')

      request = request.clone({
        setHeaders: {
          Authorization: `${token_type} ${token}`,
        },
      })
    }

    return next.handle(request)
  }
}
